import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordEnforcementService {
  private readonly storageKey: string = 'force_password_change_required';
  private required: boolean = false;
  private userIdentifier: string | null = null;

  public constructor() {
    this.readStoredRequirement();
  }

  public requirePasswordChange(userIdentifier?: string | number | null): void {
    this.userIdentifier = userIdentifier === null || userIdentifier === undefined ? null : String(userIdentifier);
    this.required = true;
    this.persistRequirement(true);
  }

  public clearPasswordChangeRequirement(): void {
    this.required = false;
    this.userIdentifier = null;
    this.persistRequirement(false);
  }

  public isPasswordChangeRequiredForUser(userIdentifier: string | number | null | undefined): boolean {
    if (!this.required || !this.userIdentifier || userIdentifier === null || userIdentifier === undefined) {
      return false;
    }

    return this.userIdentifier === String(userIdentifier);
  }

  public hasPasswordChangeRequirement(): boolean {
    return this.required;
  }

  private persistRequirement(required: boolean): void {
    try {
      if (required) {
        sessionStorage.setItem(this.storageKey, JSON.stringify({
          required: true,
          userIdentifier: this.userIdentifier
        }));
      } else {
        sessionStorage.removeItem(this.storageKey);
      }
    } catch (error) {
      console.warn('Failed to persist password change requirement:', error);
    }
  }

  private readStoredRequirement(): void {
    try {
      const storedValue = sessionStorage.getItem(this.storageKey);
      if (!storedValue) {
        this.required = false;
        this.userIdentifier = null;
        return;
      }

      const parsed = JSON.parse(storedValue) as {required?: boolean; userIdentifier?: string | null};
      this.required = parsed.required === true;
      this.userIdentifier = typeof parsed.userIdentifier === 'string' && parsed.userIdentifier.trim() !== ''
        ? parsed.userIdentifier
        : null;
    } catch (error) {
      console.warn('Failed to read password change requirement:', error);
      this.required = false;
      this.userIdentifier = null;
    }
  }
}
